@if(loading){
<div class="overlay">
  <div class="spinner-border"></div>
</div>
}

<div class="profile-page-container mb-5 pb-5 ">
  <!-- Header Section -->
  <div
    class="profile-header d-flex flex-column flex-md-row gap-3 gap-md-0 justify-content-between align-items-md-center mb-4">
    <div class="profile-info-block">
      <h1 class="profile-title">Profile Details</h1>
      <p class="profile-subtitle">Complete your business profile to start trading on the platform.</p>
    </div>
    <button type="button" class="btn-my-docs" (click)="viewMyDrive()">
      <i class="bi bi-folder-fill me-2"></i>My Documents
    </button>
  </div>

  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
    <!-- Profile Content Card -->
    <div class="profile-card">

      <!-- Section 1: Personal Information -->
      <div class="profile-section">
        <div class="section-header d-flex align-items-center mb-4">
          <span class="section-number">1</span>
          <h2 class="section-title mb-0">Personal Information</h2>
        </div>

        <div class="row justify-content-center mb-4">
          <div class="col-auto position-relative">
            <div class="avatar-container">
              @if(imgData){
              <img [src]="imgData" class="avatar-img" />
              } @else {
              <div class="avatar-placeholder">
                <i class="bi bi-person-fill"></i>
              </div>
              }
              <div class="avatar-edit-wrapper">
                <button type="button" class="avatar-edit-btn" (click)="toggleProfileOptions()">
                  <i class="bi bi-pencil-fill"></i>
                </button>
              </div>
              @if(showProfileOptions) {
              <div class="profile-options-menu">
                <div class="menu-header d-flex justify-content-between align-items-center">
                  <span>Profile Options</span>
                  <i class="bi bi-x" (click)="toggleProfileOptions()" style="cursor: pointer;"></i>
                </div>
                <div class="menu-item" (click)="triggerFileInput('profilePic')">
                  <div class="icon-box bg-primary-soft">
                    <i class="bi bi-camera-fill text-primary"></i>
                  </div>
                  <span>Replace Profile Image</span>
                </div>
                <div class="menu-item text-danger" (click)="removeProfilePic()">
                  <div class="icon-box bg-danger-soft">
                    <i class="bi bi-trash-fill text-danger"></i>
                  </div>
                  <span>Remove Profile Image</span>
                </div>
              </div>
              }
            </div>
            <input type="file" #fileInput style="display: none" (change)="handleFileSelect($event)" accept="image/*,application/pdf,.doc,.docx" />
          </div>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <div class="form-group">
              <label>First Name</label>
              <input type="text" class="form-control" placeholder="Alex" formControlName="firstName" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Last Name</label>
              <input type="text" class="form-control" placeholder="Thompson" formControlName="lastName" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Contact Number</label>
              <input type="text" class="form-control readonly-field" placeholder="+1 (555) 000-1234"
                formControlName="mobilePhone" readonly />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Email ID</label>
              <input type="email" class="form-control readonly-field" placeholder="alex.t@agricorp.com"
                formControlName="emailId" readonly />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Type of User</label>
              <input type="text" class="form-control readonly-field" placeholder="User Type" formControlName="userType" readonly 
              />
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="profile-card mt-5">
      <!-- Section 2: Company Details -->
      <div class="profile-section">
        <div class="section-header d-flex align-items-center mb-4">
          <span class="section-number bg-success-soft text-success">2</span>
          <h2 class="section-title mb-0">Company Details</h2>
        </div>

        <div class="row g-3">
          <div class="col-md-6 d-flex flex-column gap-3">
            <div class="form-group mb-0">
              <label>Company Name</label>
              <input type="text" class="form-control" placeholder="AgriCorp International"
                formControlName="companyName" />
            </div>
            <div class="form-group mb-0">
              <label>Business Licence Number</label>
              <input type="text" class="form-control" placeholder="BL-9323-X" formControlName="businessCertificate" />
            </div>
            <div class="form-group mb-0">
              <label>Office Email ID</label>
              <input type="email" class="form-control readonly-field" placeholder="contact@agricorp.com"
                formControlName="officeEmailId" />
            </div>
            <div class="form-group mb-0">
              <label>Office Contact Number</label>
              <input type="text" class="form-control readonly-field" placeholder="+1 (555) 000-0000"
                formControlName="officeContactNumber" readonly />
            </div>
          </div>
          <div class="col-md-6 d-flex flex-column gap-3">
            <div class="form-group mb-0">
              <label>Country</label>
              <input type="text" class="form-control readonly-field" placeholder="United States"
                formControlName="country" readonly />
            </div>
            <div class="form-group mb-0">
              <label>Upload Business Licence</label>
              <div class="position-relative" (click)="triggerFileInput('businessCertificate')" style="cursor: pointer;">
                <input type="text" class="form-control pe-5" placeholder="prof_ ...png (4MB)" readonly
                  style="cursor: pointer;" />
                <i class="bi bi-cloud-arrow-up-fill text-primary position-absolute top-50 end-0 translate-middle-y me-3"
                  style="font-size: 1.2rem;"></i>
              </div>
            </div>
            <div class="form-group flex-grow-1 mb-0 d-flex flex-column">
              <label>Office Address</label>
              <textarea class="form-control flex-grow-1" style="resize: none;"
                placeholder="123 Business Plaza, Suite 400, New York, NY" formControlName="officeAddress"></textarea>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="profile-card mt-5">
      <!-- Section 3: Banking Information -->
      <div class="profile-section">
        <div class="section-header d-flex align-items-center mb-4">
          <span class="section-number bg-warning-soft text-warning">3</span>
          <h2 class="section-title mb-0">Banking Information</h2>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-md-6">
            <div class="form-group">
              <label>Bank Account Number</label>
              <input type="text" class="form-control" placeholder="**** **** **** 1234"
                formControlName="bankAccountNumber" (input)="formatBankAccountNumber($event)" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Bank IFSC Code</label>
              <input type="text" class="form-control" placeholder="CHASEUS33" formControlName="bankIfscCode" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Bank Branch Address</label>
              <input type="text" class="form-control" placeholder="270 Park Ave, New York, NY 10017"
                formControlName="bankBranchAddress" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Type of Document</label>
              <mat-select class="form-control f-select-v2" [value]="selectedField" (selectionChange)="seletedFileName($event)">
                @for(doc of uploadDocuments; track doc) {
                <mat-option [value]="doc.value" [disabled]="doc.value === ''">{{doc.label}}</mat-option>
                }
              </mat-select>
              @if(showDocTypeError) {
              <div class="text-danger mt-1" style="font-size: 0.75rem;">
                <span>Please select the category before uploading</span>
              </div>
              }
            </div>
          </div>
        </div>

        <!-- Upload Zone -->
        <div class="form-group">
          <label>Upload Document</label>
          <div class="upload-dropzone" (click)="triggerFileInput(selectedField)" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
            <i class="bi bi-cloud-upload-fill upload-icon"></i>
            <p class="upload-text">Click to upload or drag and drop</p>
            <p class="upload-hint">PDF, JPG or PNG (max. 10MB)</p>
          </div>
        </div>

        <!-- File list as shown in design -->
        @if(uploadedFiles && uploadedFiles.length > 0) {
        <div class="file-list mb-4">
          @for(file of uploadedFiles; track file){
          <div class="file-item">
            <div class="file-info" (click)="viewMediaFile(file)">
              @if(file.contentType && file.contentType.includes('image')){
              <img [src]="file.fileUrl" alt="" class="file-icon" style="max-height: 40px; max-width: 40px; object-fit: contain;">
              }
              @else if(file.contentType && file.contentType.includes('application/pdf')){
              <i class="bi bi-file-earmark-pdf-fill file-icon" style="font-size: 1.5rem; color: #ef4444;"></i>
              }
              @else if(file.contentType && file.contentType.includes('application/msword')){
              <i class="bi bi-file-earmark-word-fill file-icon" style="font-size: 1.5rem; color: #2b579a;"></i>
              }
              @else{
              <i class="bi bi-file-earmark-text-fill file-icon" style="font-size: 1.5rem; color: #6c757d;"></i>
              }

              <div class="file-meta">
                <span class="file-name">{{file.fileName}}</span>
              </div>
            </div>
            <button type="button" class="btn-remove-file" (click)="deleteMedia(file.id)">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
          }
        </div>
        }
      </div>

    </div>

    <!-- Action Buttons -->
    <div class="profile-actions d-flex flex-column-reverse flex-md-row justify-content-end gap-3 mt-4">
      <button type="button" class="btn-cancel" (click)="patchProfileForm()">Cancel Changes</button>
      <button type="submit" class="btn-save">
        Save Profile Details <i class="bi bi-check-circle-fill ms-1"></i>
      </button>
    </div>
  </form>
</div>